<template>
  <div class="subpage main_area badngs" style="position: relative">
    <p class="tips_block tips_block_mainpage">温馨提示：每个账户仅能绑定最多 5 张银行卡/电子钱包。一经绑定不可随意修改。如需修改资料，请联系 24 小时在线客服为您服务。</p>
    <div class="card_management layout">
      <div class="card_management_title">
        <div>银行卡</div>
        <div>{{ bankcardLis.length }}/5</div>
      </div>
      <ul class="bankcards_list bank_list">
        <li class="bankcard_bg_added" style="position: relative" v-for="(item, index) in bankcardLis" :key="index">
          <div><img alt="" :src="item.ico" /></div>
          <div>
            <div class="bank_inner_detail">
              <div class="bank_name">{{ item.bank }}</div>
              <div class="bank_name">{{ item.bank_no }}</div>
            </div>
            <div @click="showDel(item.id)">解绑</div>
          </div>
          <div></div>
        </li>
        <li class="bankcard_bg" style="position: relative" v-if="bankcardLis.length < 5" @click="$parent.goNav('/addBankCard')">
          <div class="bank_card_default">银行卡</div>
          <div><button class="btn btn_major bankcard_section active">添加</button></div>
        </li>
      </ul>

      <div class="card_management_title">
        <div>电子钱包</div>
        <div>{{ usdtCarList.length }}/5</div>
      </div>
      <ul class="bankcards_list crypto_wallet_list">
        <li class="bankcard_bg_added" style="position: relative" v-for="(item, index) in usdtCarList" :key="index">
          <div class="bank_inner_detail" style="display: block; width: 90%">
            <div class="bank_name" style="word-break: break-all">{{ item.bank_no }}</div>
            <div class="bank_name">{{ item.bank_owner }}</div>
          </div>
          <div @click="showDel(item.id)">解绑</div>
        </li>
        <li class="bankcard_bg" v-if="usdtCarList.length < 5" style="position: relative" @click="$parent.goNav('/addUsdtAds')">
          <div class="bank_card_default">电子钱包</div>
          <div><button class="btn btn_major bankcard_section active">添加</button></div>
        </li>
      </ul>
    </div>
    <van-dialog v-model="delShow" title="解绑卡片" show-cancel-button :before-close="delCard">
      <div style="padding: 10px;20px;background:rgb(251 248 248)">
        <van-cell-group>
          <van-field v-model="pay_pass" label="支付密码" type="password" placeholder="请输入6位数字支付密码" oninput="value=value.replace(/[^0-9]/g,'')" maxlength="6" />
        </van-cell-group>
      </div>
    </van-dialog>
  </div>
</template>
<script>
export default {
  name: 'bankCard',
  data() {
    return { baseURL: '', bankcardLis: [], usdtCarList: [], pay_pass: null, delId: null, delShow: false };
  },
  created() {
    let that = this;
    that.baseURL = sessionStorage.getItem('baseURL') || '';
    console.log(sessionStorage.getItem('baseURL'));
    that.getcard();
    that.getcard1();
  },
  methods: {
    showDel(id) {
      let that = this;
      that.delId = id;
      that.pay_pass = null;
      that.delShow = true;
    },
    delCard(action, done) {
      let that = this;
      if (action === 'confirm') {
        let id = that.delId;
        let pay_pass = that.pay_pass;
        let paypasswordreg = /^[0-9]{6}$/; //只能是6位 数字
        if (paypasswordreg.test(pay_pass) == false) {
          that.$parent.showTost(0, '请输入6位数字支付密码');
          done(false);
          return;
        }
        that.$parent.showLoading();

        that.$apiFun.post('/api/delcard', { id, pay_pass }).then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }

          if (res.code == 200) {
            that.$parent.showTost(1, '解绑成功');

            that.getcard();
            that.getcard1();
          }
          that.$parent.hideLoading();

          done(true);
        });
      } else {
        done(true);
      }
    },
    getcard() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/getcard', { type: 1 })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.bankcardLis = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getcard1() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/getcard', { type: 2 })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.usdtCarList = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.select2-container--default .select2-results > .select2-results__options {
  max-height: calc(100vw / 2) !important;
}
.btn_major.bankcard_section {
  width: 95px;
  height: 36px;
  margin-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
.btn_major:active,
.btn_major.active {
  background: var(--btn_major_bg_activated) !important;
  border: var(--btn_major_borderthick_activated) solid var(--btn_major_border_activated) !important;
  color: var(--btn_major_txt_activated) !important;
  font-weight: var(--btn_major_weight_activated) !important;
  -webkit-box-shadow: var(--btn_major_shadow_activated), var(--btn_major_innershadow_activated) !important;
  box-shadow: var(--btn_major_shadow_activated), var(--btn_major_innershadow_activated) !important;
  pointer-events: all;
}
.bankcards_list li > div:last-child,
.add_bankcard > div:last-child {
  width: auto;
  margin-right: 0;
  text-align: left;
}
.bankcards_list li > div img,
.add_bankcard > div img {
  width: 80%;
}
.bankcards_list li > div:first-child,
.add_bankcard > div:first-child {
  width: 20%;
  margin-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/bankCard.vue